// extracted by mini-css-extract-plugin
export default {"root":"root--RTPSY","socialshare":"socialshare--RTPSY","socialshare-24":"socialshare-24--RTPSY","socialshare-34":"socialshare-34--RTPSY","link":"link--RTPSY"};